// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".offer-example-card{flex:1}.offer-example-card .card-header,.offer-example-card .card-footer{background-color:#104182;color:#fff}.offer-example-card .card-footer{font-size:1.1rem}.offer-example-card .card-body .card-text .title,.offer-example-card .card-body p .title{color:#104182;font-weight:bold;margin-bottom:0}.offer-example-card .card-body svg.plus-circle{position:absolute;fill:#104182;stroke:#fff;bottom:0.5rem;right:0}\n", ""]);
// Exports
module.exports = exports;
